import INFTCollections from '../../models/INFTCollections'
import AvaPepeLogo from '../../../../assets/nft-logo/AvaPepe.jpg'
import GeneralActivityDetail from '../../nftFormats/Generals/Activity/GeneralActivityDetail'
import AvaPepeDetail from '../../nftFormats/AvaPepe/Detail/AvaPepeDetail'
import AvaPepeCard from '../../nftFormats/AvaPepe/Card/AvaPepeCard'

export const AvaPepeData: INFTCollections[] = [
  {
    id: 'AvaPepe',
    tokenAddress: '0x65787a9abc4563316b20ce6c46d0f46f4e357c36',
    name: 'Ava Pepe',
    cardFormat: AvaPepeCard,
    detailFormat: AvaPepeDetail,
    activityFormat: GeneralActivityDetail,
    category: 4,
    creatorAddress: '0xB2012dA38A8991358C7736423033df25Ac50D352',
    logo: AvaPepeLogo,
    website: 'https://avapepes.com/home',
    twitter: 'avapepes',
    discord: 'https://discord.com/invite/7Err8S8FNp',
    telegram: 'https://t.me/avapepe'
  }
]

export const AvaPepeCategoryData = {
  [AvaPepeData[0].tokenAddress.toLowerCase()]: AvaPepeData[0].category
}

export interface IPepeRarityClass {
  [key: string]: { bgColor: string; percent: string }
}

export const RarityClass: IPepeRarityClass = {
  Common: {
    bgColor: 'linear-gradient(45deg, #fca04a 40%, #9f570c 60%)',
    percent: '40%'
  },
  Uncommon: {
    bgColor: 'linear-gradient(45deg, #4ad8fc 40%, #1b63d9 60%)',
    percent: '39%'
  },
  Rare: {
    bgColor: 'linear-gradient(45deg, #4afcad 40%, #46d91b 60%)',
    percent: '12%'
  },
  Super: {
    bgColor: 'linear-gradient(45deg, #fc4ae3 40%, #6620ff 60%)',
    percent: '6.5%'
  },
  Myth: {
    bgColor: 'linear-gradient(45deg, #eeedbd 40%, #ffd420 60%)',
    percent: '2%'
  },
  Legendary: {
    bgColor: 'linear-gradient(45deg, #e35252 40%, #90ff20 50%, #6bffe0 60%)',
    percent: '0.5%'
  }
}

export const AvaPepRarity: { [key: string]: { [key: string]: number } } = {
  Background: {
    Aqua: 12,
    Cafe: 28,
    'Light Blue': 13,
    Blue: 12,
    'Dark Purple': 17,
    Purple: 14,
    Red: 14,
    Luxury: 89,
    'Van Gogh': 63,
    Pink: 16,
    Stars: 35,
    Trippy: 70,
    Grey: 10,
    Avalanche: 37,
    Rooftop: 40,
    Nebula: 107,
    Yellow: 14,
    Heaven: 125,
    Green: 10,
    Hell: 126,
    Brown: 12,
    'Tropical Island': 95
  },
  Skin: {
    Yellow: 28,
    'Dark Blue': 32,
    Pink: 38,
    Red: 33,
    'Dark Green': 40,
    Purple: 37,
    Brown: 31,
    Diamond: 107,
    Rainbow: 69,
    Snowman: 92,
    Alien: 115,
    Zombie: 102,
    Cyborg: 62,
    Ice: 54,
    Robot: 62,
    Gold: 90,
    Acid: 66,
    Green: 12,
    Orange: 25,
    'Light Blue': 30
  },
  Face: {
    'Laser Beam': 85,
    'Laser Eyes': 95,
    'Avax Eyes': 13,
    'Mad Max': 64,
    'Mlg Glasses': 40,
    Monocle: 55,
    'Ninja Mask': 58,
    Eyes: 8,
    'Peace Glasses': 34,
    Pirate: 53,
    'Devil Eyes': 126,
    'Rainbow Eyes': 69,
    Robocop: 105,
    'Round Nerd Glasses': 25,
    'Ski Goggles': 28,
    'Stoned Eyes': 12,
    Sunglasses: 70,
    Visors: 32,
    '3d Glasses': 35,
    'Alien Eyes': 115,
    'Avax Gems': 88,
    'Bitcoin Sunglasses': 40,
    'Crying Eyes': 12,
    Cyborg: 107,
    'Gucci Glasses': 90,
    'Heart Sunglasses': 13
  },
  Hat: {
    'Dizzy Stars': 13,
    Dreadlock: 15,
    Fedora: 25,
    'Fisherman Hat': 11,
    Fohawk: 33,
    Hipster: 13,
    Hogwarts: 58,
    'Demon Horns': 107,
    Husky: 18,
    Halo: 125,
    'Irish Boho': 16,
    'Japanese Bandana': 69,
    'Kings Crown': 103,
    'Laurels Wrath': 91,
    Mohawk: 37,
    Mullet: 40,
    Neanderthaler: 86,
    'Neanderthaler Elder': 92,
    'Party Hat': 19,
    Pirate: 64,
    Army: 25,
    'Red Cap': 12,
    'Sm Hat': 36,
    'Samurai Helm': 103,
    'Spinner Hat': 20,
    Strawhat: 38,
    'Superman Hair': 85,
    'Top Hat': 32,
    Wizard: 58,
    'Devil Horns': 126,
    Astronaut: 87,
    'Hiphop Cap': 50,
    'Goku Hair': 95,
    Clown: 36,
    'Wrapped Tie': 62,
    Beanie: 10,
    'Bomber Hat': 12,
    'Bunny Ears': 60,
    'Captain Hat': 30,
    Cowboy: 37
  },
  Mouth: {
    Happy: 16,
    Aristocracy: 67,
    Moustache: 25,
    'Party Horn': 36,
    Pipe: 70,
    Pizza: 34,
    Rose: 55,
    Sad: 10,
    Lollypop: 85,
    Shark: 103,
    Wavy: 13,
    Bubblegum: 38,
    Cemberut: 14,
    Cigar: 40,
    Cigarette: 38,
    Clown: 33,
    Dagger: 95,
    Drool: 13,
    'Golden Teeth': 89,
    'Grind Teeth': 12
  },
  Outfit: {
    'Bitcoin Necklace': 70,
    Hawaiian: 40,
    Hogwarts: 59,
    'Holes Sleeveless Top': 10,
    Hoodie: 16,
    'Husky Coat': 62,
    Kimono: 58,
    'Kings Robe': 105,
    'Leather Jacket': 34,
    Lumberjack: 13,
    Devil: 126,
    Pirate: 92,
    Prisoner: 17,
    Rockstar: 93,
    Sailor: 33,
    'Samurai Armor': 107,
    'Ski Suit': 31,
    'Suit With Ribbon': 37,
    Superman: 87,
    'Tank Top': 12,
    Goldchain: 40,
    'Astronaut Suit': 91,
    'Tie Dye': 20,
    Toga: 101,
    'Tony Montana': 70,
    Turtleneck: 18,
    Tuxedo: 34,
    Wizard: 67,
    Angel: 125,
    'Basketball Jersey': 19,
    Bathrobe: 25,
    'Bikers Vest': 16,
    Caveman: 88,
    Clown: 52,
    Detective: 34,
    'Full Body Tattoo': 62
  }
}
